(function() {
    'use strict';

    /**
     * Repository for the PWC db data.
     */

    angular
        .module("pwc.repositories")
        .service("PwcRepository", PwcRepository);

    PwcRepository.$inject = ['lodash', '$log', 'systemPouch', '$q', 'Region', 'BUILD_NUMBER'];

    function PwcRepository(lodash, $log, systemPouch, $q, Region, BUILD_NUMBER){

        function _hydrateRegions(docs){

            $log.debug('Hydrating regions...', docs.length);

            var entities = lodash.map(docs, function(doc) {
                // remove unneeded data and add to result, need to keep legacyId for maturity calcs
                var data = lodash.omit(doc, ['type', '_rev']);
                return new Region(data);
            });

            return $q.when(entities);
        }

        function isOutOfDate(){
            return version().then(function(number){
                $log.debug('Latest Version / Running Version', number, BUILD_NUMBER);
                return number != BUILD_NUMBER ? false : true;
            });
        }

        function version(){
            return systemPouch.db().get('version').then(function(doc) {
                return lodash.get(doc, 'number');
            }).catch(function (err) {
                $log.error(err);
            });
        }

        function regions(){

            return systemPouch.fetch('region')
                .then(function(data){
                    return lodash.sortBy(data, 'name');
                })
                .then(_hydrateRegions)
                .catch(function(err){
                    $log.error(err);
                    return [];
                });
        }

        // exposed, public API
        return {
            regions: regions,
            version: version,
            isOutOfDate: isOutOfDate
        };

    }

})();
